/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type FundingRequirementType =
  typeof FundingRequirementType[keyof typeof FundingRequirementType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundingRequirementType = {
  FUNDING_REQUIRED: 'FUNDING_REQUIRED',
  PD_DECREASE_REQUIRED: 'PD_DECREASE_REQUIRED',
  FUNDING_NOT_REQUIRED: 'FUNDING_NOT_REQUIRED',
} as const;
